import { TilstandsrapportEntitiesActionCreators, TilstandsrapportEntitiesActionTypes } from './types';

// eslint-disable-next-line import/prefer-default-export
export const addTilstandsrapportEntities = (data): TilstandsrapportEntitiesActionCreators => {
  return { type: TilstandsrapportEntitiesActionTypes.ADD, data };
};
